module.exports = __webpack_public_path__ + "blackyogasymbol.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackyogasymbol.png
// module id = 875
// module chunks = 0